import { render, staticRenderFns } from "./days-in-week.vue?vue&type=template&id=6a34a8cb"
import script from "./days-in-week.ts?vue&type=script&lang=js&external"
export * from "./days-in-week.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports